'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var isActionType = function isActionType(maybeValidActionType) {
  return Boolean(typeof maybeValidActionType === 'string' && maybeValidActionType.length);
};

exports.default = isActionType;
module.exports = exports['default'];